// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  display: flex;
  justify-content: center;
  align-items: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

input {
  border: 1px solid rgb(78, 68, 68);
  text-decoration: none;
  width: 100%;
  border-radius: 2px;
  padding: 5px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.underline {
  text-decoration-line: underline !important;
}
input[id^="size-checkbox-product"] + label {
  font-size: 15px;
  padding-left: 5px;
  padding-right: 5px;
}
.btn {
  border-radius: 9999px !important;
  cursor: pointer !important;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate))
    skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate))
    skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
    scaleY(var(--tw-scale-y));
}

.btn:hover {
  border-radius: 9999px !important;
  cursor: pointer !important;
  transition-property: all;
  border-width: 0;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;

  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate))
    skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.02) scaleY(1.02);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate))
    skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
    scaleY(var(--tw-scale-y));
}
.css-13cymwt-control {
  border-color: #e6e7e8;
}
.css-13cymwt-control:hover,
.css-13cymwt-control:focus {
  border-color: #000000 !important;
  outline: none;
  box-shadow: none;
}

.btn,
.btn:hover .btn-primary,
.btn-primary:hover,
.btn-secondary,
.btn-secondary:hover,
.btn-tertiary,
.btn-tertiary:hover,
.btn-default,
.btn-default:hover {
  border: none !important;
}

.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0);
}

.hover\\:border-black:hover {
  --tw-border-opacity: 1;

  border-color: rgb(0 0 0);
}

.text-description h3 {
  font-size: 20px;
  line-height: 24px;
  padding-bottom: 15px;
  font-weight: bold;
  text-align: center;
}
.text-description p {
  font-size: 14px;
  line-height: 18px;
  padding-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf;uEACqE;EACrE;;6BAE2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,wDAAwD;EACxD,0BAA0B;;EAE1B,kBAAkB;EAClB,kBAAkB;EAClB;6EAC2E;EAC3E;;6BAE2B;AAC7B;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,gCAAgC;EAChC,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;;;;;EASE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;;EAEtB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":[".App {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\ninput {\n  border: 1px solid rgb(78, 68, 68);\n  text-decoration: none;\n  width: 100%;\n  border-radius: 2px;\n  padding: 5px;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.underline {\n  text-decoration-line: underline !important;\n}\ninput[id^=\"size-checkbox-product\"] + label {\n  font-size: 15px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.btn {\n  border-radius: 9999px !important;\n  cursor: pointer !important;\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate))\n    skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate))\n    skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))\n    scaleY(var(--tw-scale-y));\n}\n\n.btn:hover {\n  border-radius: 9999px !important;\n  cursor: pointer !important;\n  transition-property: all;\n  border-width: 0;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n\n  --tw-scale-x: 1.02;\n  --tw-scale-y: 1.02;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate))\n    skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.02) scaleY(1.02);\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate))\n    skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))\n    scaleY(var(--tw-scale-y));\n}\n.css-13cymwt-control {\n  border-color: #e6e7e8;\n}\n.css-13cymwt-control:hover,\n.css-13cymwt-control:focus {\n  border-color: #000000 !important;\n  outline: none;\n  box-shadow: none;\n}\n\n.btn,\n.btn:hover .btn-primary,\n.btn-primary:hover,\n.btn-secondary,\n.btn-secondary:hover,\n.btn-tertiary,\n.btn-tertiary:hover,\n.btn-default,\n.btn-default:hover {\n  border: none !important;\n}\n\n.border-black {\n  --tw-border-opacity: 1;\n  border-color: rgb(0 0 0);\n}\n\n.hover\\:border-black:hover {\n  --tw-border-opacity: 1;\n\n  border-color: rgb(0 0 0);\n}\n\n.text-description h3 {\n  font-size: 20px;\n  line-height: 24px;\n  padding-bottom: 15px;\n  font-weight: bold;\n  text-align: center;\n}\n.text-description p {\n  font-size: 14px;\n  line-height: 18px;\n  padding-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
